import { HeadMetadata } from '@exploration/shared-types';

// --------------------------------------------------------------------------

export const SchemaMarkupScript = ({
  metadata,
}: {
  metadata: HeadMetadata;
}) => {
  const {
    title,
    description,
    keywords,
    url,
    siteName = 'Thrivent.com',
  } = metadata;
  return (
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'http://schema.org',
        '@graph': [
          {
            '@type': 'WebPage',
            '@id': url,
            url,
            description,
            inLanguage: 'en-US',
            publisher: { '@id': 'https://thrivent.com/#organization' },
            isPartOf: { '@id': 'https://thrivent.com/#website' },
            name: title,
            keywords,
          },
          {
            '@type': 'WebSite',
            '@id': 'https://thrivent.com/#website',
            url: 'https://thrivent.com/',
            name: siteName,
            description,
            publisher: { '@id': 'https://thrivent.com/#organization' },
            potentialAction: [
              {
                '@type': 'SearchAction',
                target: {
                  '@type': 'EntryPoint',
                  urlTemplate:
                    'https://thrivent.com/search?q={search_term_string}',
                },
                'query-input': 'required name=search_term_string',
              },
            ],
            inLanguage: 'en-US',
          },
          {
            '@type': 'Organization',
            '@id': 'https://thrivent.com/#organization',
            name: 'Thrivent',
            logo: {
              '@type': 'ImageObject',
              url: 'https://cdn.thrivent.com/5f/13/47c264b148bbbed64eec802f8bad/logo-thrivent-rgb-rev.svg',
            },
            location: [
              {
                '@type': 'Place',
                name: 'Operations Center',
                address: {
                  '@type': 'PostalAddress',
                  addressLocality: 'Appleton',
                  addressRegion: 'WI',
                  postalCode: '54919-0001',
                  streetAddress: '4321 N. Ballard Rd.',
                },
              },
              {
                '@type': 'Place',
                name: 'Corporate Center',
                address: {
                  '@type': 'PostalAddress',
                  addressLocality: 'Minneapolis',
                  addressRegion: 'MN',
                  postalCode: '55415-4402',
                  streetAddress: '600 Portland Avenue S., Suite 100',
                },
              },
            ],
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '+8008474836',
              contactType: 'Customer Service',
            },
            sameAs: [
              'https://www.linkedin.com/company/6233',
              'https://www.instagram.com/thrivent/',
              'https://x.com/thrivent',
              'https://www.facebook.com/thrivent',
            ],
          },
        ],
      })}
    </script>
  );
};
